import _ from 'lodash'
import React from 'react'
import './styles.scss'

import ValueRenderer from './ValueRenderer'

const Header = ({ header }) => (
  <thead>
    <tr>
      {header.map((item, index) => (
        <th key={index}>{_.get(item, 'title')}</th>
      ))}
    </tr>
  </thead>
)

const Body = ({ body }) => (
  <tbody>
    {body.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.items.map((item, index) => (
          <td key={index}>
            <ValueRenderer
              value={item.value}
              type={item.type}
            />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
)

export class TableSection extends React.Component {
  renderNoData () {
    const { section } = this.props
    return (
      <tbody>
        <tr>
          <td
            className='nodata'
            colSpan={section.header.length}
          >
            No Data Present
          </td>
        </tr>
      </tbody>
    )
  }

  render () {
    const { section } = this.props
    const items = _.get(section, 'items')
    const isDataPresent = () => items && !_.isEmpty(items)

    if (_.isNil(section)) {
      return null
    }

    return (
      <div className='table-section'>
        <table>
          {isDataPresent() && _.get(section, 'header')
            ? (
              <Header header={section.header} />
            )
            : null}
          {isDataPresent()
            ? (
              <Body body={section.items} />
            )
            : (
              this.renderNoData()
            )}
        </table>
      </div>
    )
  }
}
